import {observer} from 'mobx-react';
import {PanelTooltip} from 'shared/components';

const Note = observer(({model}) => {
  if (!model.hasNote) return null;

  return (
    <div className='relative'>
      <PanelTooltip icon={<i className='material-symbols-solid h4'>{'description'}</i>}>{model.note}</PanelTooltip>
    </div>
  );
});

export default Note;
